module.exports = __webpack_public_path__ + "img/wifi-icon.3c4e59b8.svg";